module.exports = __webpack_public_path__ + "static/img/app_ewm.21472be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/app_ewm.png
// module id = D5BS
// module chunks = 1